import { render, staticRenderFns } from "./BaseLink.vue?vue&type=template&id=097a896a"
import script from "./BaseLink.vue?vue&type=script&lang=js"
export * from "./BaseLink.vue?vue&type=script&lang=js"
import style0 from "./BaseLink.vue?vue&type=style&index=0&id=097a896a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports